import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { resolvePostAuthPath } from '@/utils/oauth';

/**
 * Redireciona visitantes já autenticados que abriram /login (ou similar).
 * Nunca chama logout — só navega quando há destino válido pós-auth.
 */
export function useRedirectIfAuthenticated() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (loading || didRedirect.current || !user) {
      return;
    }
    const path = resolvePostAuthPath(user);
    if (path === '/login') {
      return;
    }
    didRedirect.current = true;
    navigate(path, { replace: true });
  }, [user, loading, navigate]);
}
